import { Component } from '@angular/core';
import { PopoverRef } from '../../popover/popover-ref';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-mfa-code-popover',
    templateUrl: './mfa-code-popover.component.html',
    styleUrls: ['./mfa-code-popover.component.scss'],
})
export class MfaCodePopoverComponent {
    setupCode = '';

    constructor(
        public popoverRef: PopoverRef,
        private toastr: ToastrService,
        private translate: TranslateService
    ) {
        if (this.popoverRef) {
            this.initializePopoverData();
        }
    }

    close(value = false): void {
        this.popoverRef.close(value);
    }

    copyCode(): void {
        navigator.clipboard.writeText(this.setupCode);
        this.toastr.info(
            this.translate.instant('common.info.codeCopiedToClipboard'),
            this.translate.instant('common.info.codeCopiedTitle')
        );
    }

    private initializePopoverData() {
        this.popoverRef.overlay.backdropClick().subscribe(() => {
            if (this.popoverRef.data.nullableBackdrop) {
                this.close(null);
            } else {
                this.close(false);
            }
        });
        try {
            this.setupCode = this.popoverRef.data.setupCode;
        } catch (e) {
            console.log('Data is missing');
        }
    }
}
